import { Page } from '@app/components/page/Page';
import { auditReports } from '@mi-front/api-clients';
import { Route } from 'react-router-dom';
import { useAodFactory } from '../aod-rules-add/custom/AodFactory';
import { AodRuleInfo } from './components/AodRuleInfo';
import { AodRuleRunsTab } from './components/AodRuleRunsTab';
import { AodRuleViewHeader } from './components/AodRuleViewHeader';

interface Props {
  path: string;
  rule: auditReports.AodRule;
}

/**
 * Tabbed screen for AOD rule view: header with path-based tabs and Route-based content.
 * Mirrors the structure of the fragments view ScreenP.
 */
export function AodRuleViewScreenP({ path, rule }: Props) {
  const { views } = useAodFactory(rule.reportType);
  const { ReportConfig, ExportOptions, ExportConditions } = views;

  return (
    <Page>
      <AodRuleViewHeader rule={rule} />
      <Route
        path={`${path}/report-config`}
        render={() => (
          <Page.Content>
            <ReportConfig reportConfig={rule.reportConfig} />
          </Page.Content>
        )}
      />
      {ExportOptions && (
        <Route
          path={`${path}/export-options`}
          render={() => (
            <Page.Content>
              <ExportOptions exportOptions={rule.exportOptions} />
            </Page.Content>
          )}
        />
      )}
      {ExportConditions && (
        <Route
          path={`${path}/export-conditions`}
          render={() => (
            <Page.Content>
              <ExportConditions exportConditions={rule.exportConditions} />
            </Page.Content>
          )}
        />
      )}
      <Route path={`${path}/runs`} render={() => <AodRuleRunsTab rule={rule} />} />
      <Route
        exact
        path={path}
        render={() => (
          <Page.Content>
            <AodRuleInfo rule={rule} />
          </Page.Content>
        )}
      />
    </Page>
  );
}
